export default __webpack_public_path__ + "static/media/logo-vk-24.4a6e8709.svg";